import { useEffect, useState } from "react";
import { api } from "./api";
import { LoadingTerminal } from "./components/LoadingTerminal";
import { AdminPage } from "./pages/AdminPage";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { MethodologyPage } from "./pages/MethodologyPage";
import { PortalPage } from "./pages/PortalPage";
import { PresentationPage } from "./pages/PresentationPage";
import { ProjectionsPage } from "./pages/ProjectionsPage";
import type { Session } from "./types";

const nav = [
  ["/painel", "Mercado"],
  ["/projecoes", "Projeções"],
  ["/metodologia", "Metodologia"],
] as const;

function Header({ session }: { session: Session }) {
  const path = window.location.pathname;
  const links = session.role === "admin" ? [...nav, ["/admin", "Admin"] as const] : nav;

  async function logout() {
    await fetch("/api/session", { method: "DELETE", credentials: "same-origin" });
    window.location.assign("/login");
  }

  return (
    <header className="site-header">
      <a className="brand-lockup" href="/" aria-label="Início do ASTER">
        <span className="brand-mark-shell">
          <img src="/brand/asterum-icon-white.svg" alt="" />
        </span>
        <span>
          <strong>ASTER</strong>
          <small>Asterum Private Network</small>
        </span>
      </a>
      <nav className="main-nav" aria-label="Navegação principal">
        {links.map(([href, label]) => {
          const active = path.startsWith(href);
          return <a key={href} href={href} className={active ? "active" : undefined}>{label}</a>;
        })}
      </nav>
      <div className="account-menu">
        <span className="network-dot" />
        <div><strong>{session.role === "admin" ? "Administrador" : "Investidor"}</strong><small>{session.username}</small></div>
        <button type="button" onClick={logout}>Sair</button>
      </div>
      <button className="mobile-logout" type="button" onClick={logout}>Sair</button>
    </header>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-logo-plate"><img src="/brand/asterum-wordmark-tagline.svg" alt="Asterum Beyond Intelligence" /></div>
      <div><strong>ASTER</strong><span>Unidade interna de performance. Não é um criptoativo negociado publicamente.</span></div>
      <span>Fórmula v1.0 | Max supply 250.000</span>
    </footer>
  );
}

export function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const path = window.location.pathname;

  useEffect(() => {
    api<{ user: Session }>("/api/session")
      .then((payload) => {
        setSession(payload.user);
        if (window.location.pathname === "/login") window.location.assign("/");
      })
      .catch(() => {
        if (import.meta.env.DEV) setSession({ username: "admin-local", role: "admin" });
        else if (window.location.pathname !== "/login") window.location.assign(`/login?next=${encodeURIComponent(window.location.pathname)}`);
      })
      .finally(() => setLoading(false));
  }, []);

  if (path === "/login") return <LoginPage />;
  if (loading || !session) {
    return <LoadingTerminal message="Sincronizando a Asterum Private Network…" />;
  }

  if (path.startsWith("/apresentacao")) return <PresentationPage />;

  let page = path === "/" ? <PortalPage /> : <DashboardPage />;
  if (path.startsWith("/painel")) page = <DashboardPage />;
  if (path.startsWith("/projecoes")) page = <ProjectionsPage />;
  if (path.startsWith("/metodologia")) page = <MethodologyPage />;
  if (path.startsWith("/admin")) page = session.role === "admin" ? <AdminPage /> : <DashboardPage />;

  return <><Header session={session} />{page}<Footer /></>;
}
